import { createFileRoute } from '@tanstack/react-router';
import { FileSignature } from 'lucide-react';
import { ComingSoon } from '@/components/layout/ComingSoon';

export const Route = createFileRoute('/_app/lancamentos/demonstracoes')({
  component: DemonstracoesPage,
});

function DemonstracoesPage() {
  return (
    <ComingSoon
      eyebrow="Lançamento · Anual"
      title="Demonstrações"
      description="Demonstrações contábeis (DRE, balanço, fluxo de caixa) do exercício."
      icon={FileSignature}
      bullets={[
        'Balanço patrimonial assinado',
        'DRE e DFC do exercício',
        'Notas explicativas',
      ]}
      etaLabel="próxima fase"
    />
  );
}
